import { formatMX } from "@/Utils/Fomat.price";
import { useRef } from "react";
import Skeleton from "react-loading-skeleton";
import { BarcodeComponent } from "../Index";
import { useTicketCart } from "@/Hooks/TicketCart/useTicketCart";
//import { serialxd } from "@/Service/SerialImpTerm";

type Props = {
  nameArticle?: string;
  TotalQuantity?: number;
  TotalSalesPrice?: number;
  OrderNo?: string;
  PrintTitle?: string;
  FechaActual?: string;
  OrderCode?: string;
};

const TicketPrint = ({
  nameArticle,
  TotalQuantity,
  TotalSalesPrice,
  OrderNo,
  PrintTitle,
  FechaActual,
  OrderCode,
}: Props) => {
  //referencia
  const printRef = useRef<HTMLDivElement | null>(null);
  const { addTicketProduct } = useTicketCart();

  // const TotalSalesPrice = addTicketProduct.reduce((acc, item) => {
  //   return acc + (item.price ?? 0) * (item.quantity ?? 0);
  // }, 0);

  // const TotalQuantity = addTicketProduct.reduce((acc, item) => {
  //   return acc + (item.quantity ?? 0);
  // }, 0);

  // const nameArticle = addTicketProduct?.map((x) => x.productName)?.join(",");

  return (
    <div className="row" ref={printRef}>
      <div className="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
        <div className="ps-block--checkout-order">
          <div className="ps-block__content text_Center___develop">
            <span>
              <i className="develop___icons fa-sharp-duotone fa-solid fa-bag-shopping"></i>
            </span>
            <figure>
              <h2>¡Gracias por tu compra!</h2>
            </figure>
            {addTicketProduct.length > 1 ? (
              <>
                <strong className="develop___text">Articulos:</strong>
                {addTicketProduct.map((item, index) => (
                  <div key={index}>
                    <h3>{item.productName} </h3>
                    <strong>
                      {" "}
                      {item.quantity} x $ {formatMX(item.price)}
                    </strong>
                    {/* <strong className="develop___text develop___salto_text">
                    Cantidad:
                  </strong>
                  <h3>{item.quantity ?? 0 > 0 ? item.quantity : 1}</h3> */}
                  </div>
                ))}
              </>
            ) : (
              <>
                <strong className="develop___text">Articulo:</strong>
                <h3>{addTicketProduct[0]?.productName}</h3>
                <strong className="develop___text develop___salto_text">
                  Cantidad:
                </strong>
                <h3>{addTicketProduct[0]?.quantity}</h3>
              </>
            )}
            {/* <strong className="develop___text">Articulo:</strong>
            <h3>{Names}</h3>
            <strong className="develop___text develop___salto_text">
              Cantidad:
            </strong>
            <h3>{Quantity ?? 0 > 0 ? Quantity : 1}</h3> */}
            <strong className="develop___text develop___salto_text">
              Total de la orden:
            </strong>
            <h3 className="develop___salto_text">
              $ {TotalSalesPrice ?? 0 > 0 ? formatMX(TotalSalesPrice ?? 0) : <Skeleton />}
            </h3>
            <strong className="develop___text develop___salto_text">
              Número de pedido:
            </strong>
            <h3>{OrderNo}</h3>
            <strong className="develop___text develop___salto_text">
              Metodo de entrega:
              <h3>{PrintTitle}</h3>
            </strong>
            {PrintTitle == "Recoger en tienda" ? (
              <>
                <strong className="develop___text develop___salto_text">
                  Entrega en:
                  <h3>Soriana Híper San Pedro</h3>
                </strong>
                <strong className="develop___text develop___salto_text">
                  A partir del día:
                  <h3>{FechaActual}</h3>
                </strong>
              </>
            ) : (
              ""
            )}
            <strong className="develop___text develop___salto_Codbarra">
              Presenta este código de barras impreso al pagar en tienda
            </strong>
            <div className="row">
              <div className="col-md-12 col-12">
                {
                  <BarcodeComponent
                    orderCode={OrderCode ?? ""}
                    width={2}
                    height={100}
                  />
                }
              </div>
            </div>
            <strong className="develop___text">
              El código tendrá validez solo por 24 hrs. a partir de esta
              confirmación
            </strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketPrint;
